<template>
    <div>
        <div class="content-box">
            <div class="ml20 font12px mb10" v-if="isMultipleCol">
                <span class="text-color-primary pointer mr6" @click="handleCheckAll(true)">全选</span>/<span class="text-color-primary pointer ml6" @click="handleCheckAll(false)">取消</span>
            </div>
            <div class="group-item-1" :class="isMultipleCol?'multiple-col pl20':''" v-for="group1 in fieldsData" :key="group1.id">
                <div class="group-title mt10 mb10">
                    <el-checkbox
                        :disabled="group1.disabled||isView"
                        v-model="group1.checked"
                        @change="handleCheck(group1, $event)">
                        <span>{{group1.display_name}}</span>
                    </el-checkbox>
                </div>
                <div class="group-content">
                    <template v-for="group2 in group1.children">
                        <el-checkbox
                            class="ml40 mb6"
                            :disabled="group2.disabled||isView"
                            v-model="group2.checked"
                            @change="handleCheck(group2, $event)">
                            <span>{{group2.display_name}}</span>
                        </el-checkbox>
                    </template>
                </div>
            </div>
        </div>
        <div class="dialog-footer pt20 tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div class="dialog-footer pt20 tac" v-else>
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash';
    export default {
        name: "BaseRoleFieldModal",
        props:{
            fields: {
                type: Array,
                required: true
            },
            page:{
                type: Object,
                required: true
            },
            isView:{
                type: Boolean,
                required:true,
            },
            actionType:{
                type: String,
                required: true
            },
            cbs:{
                type:Object,
            },
        },
        data(){
            return {
                fieldsData: this.fields,
                curErrMsg:null,
            }
        },
        computed: {
            isMultipleCol(){
                /* 特殊页面需要把维度改为一行多列：
                    a.苹果渠道下的系列广告组、系列广告
                    b.智能托管：通知人的配置*/
                let spePageList = [
                    'apple_org',
                    'apple_campaign',
                    'apple_adgroup',
                    'apple_keyword',
                    'apple_search_term',
                    'apple_negative_keyword',
                    'apple_ad',
                ];
                return (this.actionType=='dimensions'&&spePageList.includes(this.page.name))||(this.actionType=='notifier'&&this.page.name=='intelligent_managed_rule');
            },
            isCheckAll(){
                return this.fieldsData.every(item=>item.checked);
            },
        },
        watch: {
            fields: {
                handler(new_value) {
                    if(Array.isArray(new_value)&&new_value.length>0){
                        this.fieldsData = this._fmtTreeData(cloneDeep(new_value));
                    }
                },
                deep: true,
                immediate: true
            }
        },
        methods:{
            handleClose(){
                this.$emit('close');
            },
            handleCheck(data, val) {
                let isParent = data.children&&data.children.length>0;
                let parentNode = this._findModuleById(this.fieldsData,data.pid);
                let errArr = [];
                if(isParent){
                    // 父级
                    let children = data.children;
                    children.forEach(item=>{
                        if(val===false&&(item.default_check=='1')){
                            this.$set(item,'checked',true);
                            this.$set(data,'checked',true);
                            if(item.default_check=='1'){
                                errArr.push(item);
                            }
                        }else{
                            if(!item.disabled){
                                this.$set(item,'checked',val);
                            }
                        }
                    });
                }else{
                    // 子级
                    if(data.default_check=='1'){
                        this.$set(data,'checked',true);
                        if(!val){
                            errArr.push(data);
                        }
                    }else{
                        if(parentNode){
                            if(val){
                                this.$set(parentNode,'checked',true);
                            }else{
                                if(parentNode.children.every(item=>item.checked==false)){
                                    this.$set(parentNode,'checked',false);
                                }
                            }
                        }
                    }
                }

                if(errArr.length>0){
                    let nameStr = errArr.map(item=>item.display_name).join('、');
                    this.$message.error('【'+nameStr+'】字段为必选项');
                }
            },
            handleSubmit() {
                let actionIds = this._getCheckedVal(this.fieldsData,[]);
                this.cbs.onSubmit({
                    page:this.page,
                    actionIds,
                });
                this.handleClose();
            },
            handleCheckAll(val){
                if(this.isView) return ;
                let errArr = [];
                this.fieldsData.forEach(item=>{
                    if(item.disabled) return;
                    if(val===true||item.default_check!='1'){
                        this.$set(item,'checked',val);
                        // item.checked = val;
                    }else{
                        errArr.push(item);
                    }
                });
                if(errArr.length>0){
                    let nameStr = errArr.map(item=>item.display_name).join('、');
                    this.$message.error('【'+nameStr+'】字段为必选项');
                }
            },
            _findModuleById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _setChildrenChecked(module,val){
                let childFields = (module.children||[]).filter(item=>!item.disabled);
                if(val){
                    module.checked = val;
                }else{
                    if(module.default_check=='1'){
                        if(this.curErrMsg){
                            this.curErrMsg.close();
                        }
                        this.curErrMsg = this.$message.error('【'+module.display_name+'】字段为必选项');
                        module.checked = true;
                        this.$nextTick(()=>{
                            let pModule = this._findModuleById(this.fieldsData,module.pid);
                            if((pModule.children||[]).every(item=>item.checked===true)){
                                this.$set(pModule,'checked',true);
                            }
                        })
                    }else{
                        module.checked = val;
                    }
                }
                childFields.forEach(item=>{
                    this._setChildrenChecked(item,val);
                });
            },
            _fmtTreeData(data) {
                data.forEach((v) => {
                    if(v.default_check==='1'){
                        /* 如果当前是必选项，则默认选中 */
                        this.$set(v,'checked',true);
                    }
                    let childFields = v.children||[];
                    if (childFields.length > 0) {
                        if(childFields.some(item=>item.checked===true||item.default_check==='1')){
                            /* 如果子级里有已选中，则父级需要选中 */
                            this.$set(v,'checked',true);
                        }
                        this._fmtTreeData(childFields);
                    }
                });
                return data;
            },
            _getCheckedVal(list,result){
                list.forEach(item=>{
                    if(item.checked){
                        result.push(item.id);
                    }
                    if(item.children&&item.children.length>0){
                        return this._getCheckedVal(item.children,result);
                    }
                });
                return result;
            },
        },

    }
</script>

<style lang="scss" scoped>
    .multiple-col{
        display: inline-block;
        min-width: 180px;
    }
    .content-box{
        max-height: 400px;
        overflow-y: auto;
    }
</style>
